export default class Acquired {
  constructor(public readonly categoryName: string) {}
}
